var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDataBarGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6.55228 12 7 12.4477 7 13L7 20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20L5 13C5 12.4477 5.44772 12 6 12Z",
    fill: "#040405"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.5523 3 13 3.44772 13 4L13 20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20L11 4C11 3.44772 11.4477 3 12 3Z",
    fill: "#040405"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18.5523 9 19 9.44772 19 10V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V10C17 9.44772 17.4477 9 18 9Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataBarGraph);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDEyQzYuNTUyMjggMTIgNyAxMi40NDc3IDcgMTNMNyAyMEM3IDIwLjU1MjMgNi41NTIyOCAyMSA2IDIxQzUuNDQ3NzIgMjEgNSAyMC41NTIzIDUgMjBMNSAxM0M1IDEyLjQ0NzcgNS40NDc3MiAxMiA2IDEyWiIgZmlsbD0iIzA0MDQwNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDNDMTIuNTUyMyAzIDEzIDMuNDQ3NzIgMTMgNEwxMyAyMEMxMyAyMC41NTIzIDEyLjU1MjMgMjEgMTIgMjFDMTEuNDQ3NyAyMSAxMSAyMC41NTIzIDExIDIwTDExIDRDMTEgMy40NDc3MiAxMS40NDc3IDMgMTIgM1oiIGZpbGw9IiMwNDA0MDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCA5QzE4LjU1MjMgOSAxOSA5LjQ0NzcyIDE5IDEwVjIwQzE5IDIwLjU1MjMgMTguNTUyMyAyMSAxOCAyMUMxNy40NDc3IDIxIDE3IDIwLjU1MjMgMTcgMjBWMTBDMTcgOS40NDc3MiAxNy40NDc3IDkgMTggOVoiIGZpbGw9IiMwNDA0MDUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };